module.exports = __webpack_public_path__ + "img/globe1.600a3b8e.png";